import { render, staticRenderFns } from "./otherindex.vue?vue&type=template&id=bd0cfd02&scoped=true&"
import script from "./otherindex.vue?vue&type=script&lang=js&"
export * from "./otherindex.vue?vue&type=script&lang=js&"
import style0 from "./otherindex.vue?vue&type=style&index=0&id=bd0cfd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0cfd02",
  null
  
)

export default component.exports